import ComponentLoader from "@ch/components/Loaders/ComponentLoader";
import type { FC } from "react";
// import { useCallback, useState } from "react";
import { Navigate } from "react-router-dom";
// import KemTour2 from "@ch/assets/images/kem-tour-2.png";
// import KemTour3 from "@ch/assets/images/kem-tour-3.png";
// import KemTour4 from "@ch/assets/images/kem-tour-4.png";
import useKemGate from "./hooks/useKemGate";
// import WelcomeStep1 from "./components/WelcomeStep1";
// import WelcomeStep5 from "./components/WelcomeStep5";
// import WelcomeStepDefaultLayout from "./components/WelcomeStepDefaultLayout";

// const WELCOME_STEP_STORAGE_KEY = "hasSeenKemWelcomeSteps";

const KemIndexPage: FC = () => {
  const kemGate = useKemGate();
  const target = kemGate.target;
  const hasCheckedHealth = kemGate.hasCheckedHealth;
  // const navigate = useNavigate();

  // const hasSeenTour =
  //   typeof window !== "undefined" &&
  //   localStorage.getItem(WELCOME_STEP_STORAGE_KEY) === "true";

  // const [step, setStep] = useState(1);

  // const onFinishTour = useCallback(() => {
  //   localStorage.setItem(WELCOME_STEP_STORAGE_KEY, "true");
  //   void navigate(`/kem/${target}`, { replace: true });
  // }, [navigate, target]);

  // const getStep = useCallback(
  //   (s: number) => {
  //     switch (s) {
  //       case 1:
  //         return <WelcomeStep1 onNext={() => setStep(2)} />;
  //       case 2:
  //         return (
  //           <WelcomeStepDefaultLayout
  //             mainImage={KemTour2}
  //             onNext={() => setStep(3)}
  //             onSkip={onFinishTour}
  //             step={step}
  //             text="Hi! I’m KEM, your friendly AI healthcare assistant. I’m here 24/7 to help you understand symptoms, get wellness tips, and answer your health questions — anytime, anywhere."
  //           />
  //         );
  //       case 3:
  //         return (
  //           <WelcomeStepDefaultLayout
  //             mainImage={KemTour3}
  //             onNext={() => setStep(4)}
  //             onSkip={onFinishTour}
  //             step={step}
  //             text="A caring AI buddy built to make health simple, safe, and easy to talk about—whenever you need."
  //           />
  //         );
  //       case 4:
  //         return (
  //           <WelcomeStepDefaultLayout
  //             mainImage={KemTour4}
  //             onNext={() => setStep(5)}
  //             onSkip={onFinishTour}
  //             step={step}
  //             text="Your privacy matters. All conversations with KEM are confidential, and your data is securely stored and never shared without your consent."
  //           />
  //         );
  //       case 5:
  //         return <WelcomeStep5 />;
  //       default:
  //         return <WelcomeStep1 onNext={() => setStep(2)} />;
  //     }
  //   },
  //   [onFinishTour, step],
  // );

  // // if user has not seen tour, show tour steps
  // if (!hasSeenTour)
  //   return (
  //     <div className="flex h-full w-full items-center justify-center">
  //       {getStep(step)}
  //     </div>
  //   );

  if (!hasCheckedHealth) {
    return <ComponentLoader />;
  }

  return <Navigate replace to={`/kem/${target}`} />;
};

export default KemIndexPage;
